export default __webpack_public_path__ + "static/media/bell-ringing.7c2d5976.svg";